import { gql } from 'graphql-tag';

// Mutation to start the annuals export job
export const EXPORT_ANNUALS = gql`
  mutation GetAccountAnnualsReport($input: AccountMembersInput!) {
    getAccountAnnualsReport(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export status
export const ANNUALS_EXPORT_STATUS = gql`
  subscription AccountAnnualsExportStatus($jobId: String!) {
    accountAnnualsExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
    }
  }
`;

// Query to get download URL when complete
export const GET_ANNUALS_EXPORT_DOWNLOAD_URL = gql`
  query GetAccountAnnualsExportDownloadUrl($jobId: String!) {
    getAccountAnnualsExportDownloadUrl(jobId: $jobId)
  }
`;
